require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-three-laws-of-interaction-design.json") })
        }
      }, "path---blog-the-three-laws-of-interaction-design");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-three-laws-of-interaction-design!./.cache/json/blog-the-three-laws-of-interaction-design.json
// module id = 1096
// module chunks = 231608221292675